<template>
  <div style="display: flex; flex-direction: column; width: 100%; height: 92vh">
    <div
      class="tab-details"
      style="flex-grow: 1; padding: 5%; overflow: auto"
      ref="scrollDiv"
    >
      <div v-for="(slide, index) in slideContent" :key="index">
        <tab name="" :selected="index == 1 ? true : false">
          <primer-default :slide="slide" v-if="slide.template== 'default'"></primer-default>
          <primer-table :slide="slide" v-if="slide.template== 'table'"></primer-table>
          <primer-row :slide="slide" v-if="slide.template== 'row'"></primer-row>
        </tab>
      </div>
    </div>
    <div style="flex: 5"></div>
    <div>
      <div class="buttons text-xs-center">
        <v-btn
          large
          round
          outline
          color="primary"
          @click="changeTab(-1)"
          v-show="showBackArrow"
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-btn large round outline color="primary" @click="backToStart()">
          <v-icon>home</v-icon>
        </v-btn>
        <v-btn
          large
          round
          outline
          color="primary"
          @click="changeTab(1)"
          v-if="showForwardArrow"
        >
          <v-icon>arrow_forward</v-icon>
        </v-btn>
        <v-btn
          large
          round
          outline
          color="primary"
          @click="()=>$router.push('/Paleography')"
          v-show="
            activeTabIndex == slideContent.length - 1 &&
            !$router.currentRoute.path.toLowerCase().includes('public')
          "
        >
          <v-icon>check</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>
    
<script>
import Vue from "vue";
import PrimerIntro from "./PrimerIntro.vue";
import PrimerTable from "./PrimerTable.vue";
import PrimerRow from "./PrimerRow.vue";
import PrimerDefault from "./PrimerDefault.vue";
export default {
  props: {
    slideContent: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    "primer-intro": PrimerIntro,
    "primer-table": PrimerTable,
    "primer-row": PrimerRow,
    "primer-default": PrimerDefault,
  },
  data() {
    return {
      tabs: [],
      activeTabIndex: 0,
      totalTabs: 0,
      slidesNum: this.slideContent.length
    };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.totalTabs = this.tabs.length;
  },
  methods: {
    changeTab(direction) {
      this.tabs.forEach((tab) => {
        tab.isActive = false;
      });
      this.activeTabIndex = this.activeTabIndex + direction;
      this.tabs[this.activeTabIndex].isActive = true;
      this.$refs.scrollDiv.scrollTop = 0;
    },
    backToStart() {
      this.$parent.startLesson = false;
      this.changeTab(0);
      this.activeTabIndex = 0;
      this.$refs.scrollDiv.scrollTop = 0;
    },
  },
  computed: {
    showBackArrow() {
      return this.activeTabIndex > 0
    },
    showForwardArrow(){
      return this.activeTabIndex < this.slideContent.length - 1
    }
  },
};
Vue.component("tab", {
  template: `<div v-if="isActive"><slot></slot></div>`,
  props: {
    name: { required: false },
    selected: { default: false },
  },
  data() {
    return {
      isActive: false,
    };
  },
  created() {
    this.isActive = this.selected;
  },
});
</script>

<style scoped>
.buttons {
  box-shadow: 0px -5px 5px rgba(0, 0, 0, 0.15);
  position: sticky;
  width: 100%;
  background-color: white;
  bottom: 0px;
  min-height: 0;
  display: flex;
  justify-content: center;
  z-index: 99;
}
</style>